@if (workers?.length > 0) {
  <form
    #workerForm="ngForm"
    role="form"
    [attr.aria-label]="'Worker selection form'"
  >
    <!-- Show this section if worker length is greater than 10 -->
    @if (workers?.length > 10) {
      <div class="row" role="region" [attr.aria-label]="'Worker selection dropdown'">
        <div class="col-md-12">
          <label class="fw-600" [attr.aria-label]="'Select a worker'">
            <app-csw-text
              [text]="widgetResourceHeadingTemplate | translation : 'template_content' : lang"
              customClass="fw-600"
            />
          </label>
          <ng-select
            id="store"
            name="store"
            placeholder=""
            [multiple]="false"
            [(ngModel)]="selectedWorkerId"
            (change)="onWorkerChange()"
            [required]="true"
            #workerControl="ngModel"
            [ngClass]="{
              'is-invalid': workerControl.touched && workerControl.invalid
            }"
            [attr.aria-required]="true"
            [attr.aria-invalid]="workerControl.touched && workerControl.invalid"
            role="combobox"
            aria-haspopup="listbox"
          >
            <ng-option [value]="0" [attr.aria-label]="'Select anyone'">
              <div class="d-flex align-items-center">
                <div class="avatar">
                  <img
                    class="default-avatar rounded-circle"
                    src="{{ baseUrl }}/img/sample-avatar.png"
                    alt="Anyone Avatar"
                  />
                </div>
                <div class="description">
                  <div class="cbw-title">Anyone</div>
                </div>
              </div>
            </ng-option>
            @for (worker of workers; track worker.id) {
              @if (worker.id != null) {
                <ng-option
                  [value]="worker.id"
                  [attr.aria-label]="(worker.is_resource === 0 ? worker.resource_name : (worker | translation : 'booking_label' : lang)) + ' - ' + (worker.is_resource === 0 ? (worker | translation : 'job_title' : lang) : (worker | translation : 'description' : lang))"
                >
                  <div class="d-flex align-items-center">
                    <div class="avatar">
                      @if (worker.avatar !== null) {
                        <img
                          #image
                          class="resource-avatar rounded-circle"
                          src="{{ workerAvatarBaseUrl }}{{ worker.uuid }}/thumb_{{ worker.avatar }}"
                          (error)="image.src = baseUrl + '/img/sample-avatar.png'"
                          alt="Worker Avatar"
                        />
                      }
                      @if (worker.avatar === null) {
                        <img
                          class="default-avatar rounded-circle"
                          src="{{ baseUrl }}/img/sample-avatar.png"
                          alt="Anyone Avatar"
                        />
                      }
                    </div>
                    <div class="description">
                      <div class="cbw-title">
                        @if (worker.is_resource === 0) {
                          {{ worker.resource_name }}
                        }
                        @if (worker.is_resource === 1) {
                          {{ worker | translation : "booking_label" : lang }}
                        }
                      </div>
                      @if (worker.is_resource === 0) {
                        <div class="cbw-function">
                          {{ worker | translation : "job_title" : lang }}
                        </div>
                      }
                      @if (worker.is_resource !== 0) {
                        <div class="cbw-function">
                          {{ worker | translation : "description" : lang }}
                        </div>
                      }
                    </div>
                  </div>
                </ng-option>
              }
            }
          </ng-select>
          @if (workerControl.touched && !workerControl.valid) {
            <div class="text-danger" role="alert" aria-live="polite">
              @if (workerControl.errors.required) {
                <div>This field is required.</div>
              }
            </div>
          }
        </div>
      </div>
    }
    <!-- Show this section if worker length is less than 10 -->
    @if (workers?.length > 0 && workers?.length <= 10) {
      <div role="region" [attr.aria-label]="'Worker selection cards'">
        <div role="heading" aria-level="2" [attr.aria-label]="'Select a worker'">
          <app-csw-text
            [text]="widgetResourceHeadingTemplate | translation : 'template_content' : lang"
            customClass="fw-600"
          />
        </div>
        <div class="row" role="list" [attr.aria-label]="'Available workers'">
          @if (workers?.length > 1) {
            <div
              class="worker-slot-card col-md-6 col-lg-4 mt-3"
              (click)="selectedWorkerId = 0; onWorkerChange()"
              role="listitem"
              [attr.aria-label]="'Select anyone'"
              [attr.aria-selected]="selectedWorkerId === 0"
            >
              <app-info-card
                [showCardBorder]="true"
                [showShadow]="false"
                [showBody]="true"
                [isSelected]="selectedWorkerId === 0"
                [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
              >
                <div cardBody>
                  <div class="d-flex align-items-center justify-content-between">
                    <div class="d-flex align-items-center">
                      <div class="avatar">
                        <img
                          class="default-avatar rounded-circle"
                          src="{{ baseUrl }}/img/sample-avatar.png"
                          alt="Anyone Avatar"
                        />
                      </div>
                      <div class="description">
                        <div class="cbw-title">
                          {{ widgetAnyoneLabelTemplate | translation : "template_content" : lang }}
                        </div>
                        <div class="cbw-function">
                          {{ widgetAnyoneDescTemplate | translation : "template_content" : lang }}
                        </div>
                      </div>
                    </div>
                    <div class="next-arrow-container">
                      @if (selectedWorkerId === 0) {
                        <span (click)="next()" [attr.aria-label]="'Continue with anyone'">
                          <img
                            [src]="baseUrl + '/images/next_icon_widget.svg'"
                            width="26px"
                            alt="Continue with anyone"
                          />
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </app-info-card>
            </div>
          }
          @for (worker of workers; track worker) {
            @if (worker.id != null) {
              <div
                class="worker-slot-card mt-3 col-md-6 col-lg-4"
                (click)="selectedWorkerId = worker.id; onWorkerChange()"
                role="listitem"
                [attr.aria-label]="(worker.is_resource === 0 ? worker.resource_name : (worker | translation : 'booking_label' : lang)) + ' - ' + (worker.is_resource === 0 ? (worker | translation : 'job_title' : lang) : (worker | translation : 'description' : lang))"
                [attr.aria-selected]="selectedWorkerId === worker.id"
              >
                <app-info-card
                  [showCardBorder]="true"
                  [showShadow]="false"
                  [showBody]="true"
                  [isSelected]="selectedWorkerId === worker.id"
                  [selectedCardColor]="widgetService?.widgetConf?.header_background_color"
                >
                  <div cardBody>
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="d-flex align-items-center">
                        <div class="avatar">
                          @if (worker.avatar !== null) {
                            <img
                              alt="Worker Avatar"
                              #image
                              class="resource-avatar rounded-circle"
                              src="{{ workerAvatarBaseUrl }}{{ worker.uuid }}/thumb_{{ worker.avatar }}"
                              (error)="image.src = baseUrl + '/img/sample-avatar.png'"
                            />
                          }
                          @if (worker.avatar === null) {
                            <img
                              alt="Anyone Avatar"
                              class="default-avatar rounded-circle"
                              src="{{ baseUrl }}/img/sample-avatar.png"
                            />
                          }
                        </div>
                        <div class="description">
                          <div class="cbw-title">
                            @if (worker.is_resource === 0) {
                              {{ worker.resource_name }}
                            }
                            @if (worker.is_resource === 1) {
                              {{ worker | translation : "booking_label" : lang }}
                            }
                          </div>
                          @if (worker.is_resource === 0) {
                            <div class="cbw-function">
                              {{ worker | translation : "job_title" : lang }}
                            </div>
                          }
                          @if (worker.is_resource !== 0) {
                            <div class="cbw-function">
                              {{ worker | translation : "description" : lang }}
                            </div>
                          }
                        </div>
                      </div>
                      <div class="next-arrow-container">
                        @if (selectedWorkerId === worker.id) {
                          <span
                            (click)="next()"
                            [attr.aria-label]="'Continue with ' + (worker.is_resource === 0 ? worker.resource_name : (worker | translation : 'booking_label' : lang))"
                          >
                            <img
                              alt="Continue"
                              [src]="baseUrl + '/images/next_icon_widget.svg'"
                              width="26px"
                            />
                          </span>
                        }
                      </div>
                    </div>
                  </div>
                </app-info-card>
              </div>
            }
          }
        </div>
      </div>
    }
    <div class="d-flex justify-content-end mt-4 mb-4 cbw-custom-navigation" role="navigation" [attr.aria-label]="'Form navigation'">
      <div class="me-2">
        <app-button
          id="{{ 'lead-workers-selection-previous-btn' }}"
          (clickEvent)="previous()"
          [fontColor]="widgetService?.widgetConf?.button_font_color"
          [backgroundColor]="widgetService?.widgetConf?.button_background_color"
          role="button"
          [attr.aria-label]="'Go to previous step'"
        >
          <span class="custom-button-icon back"></span>
          {{ "form_fields.previous" | translate }}
        </app-button>
      </div>
      <div>
        <app-button
          id="{{ 'lead-workers-selection-next-btn' }}"
          (clickEvent)="next()"
          [isDisabled]="selectedWorkerId === null || selectedWorkerId === undefined"
          [fontColor]="widgetService?.widgetConf?.button_font_color"
          [backgroundColor]="widgetService?.widgetConf?.button_background_color"
          role="button"
          [attr.aria-label]="'Continue to next step'"
          [attr.aria-disabled]="selectedWorkerId === null || selectedWorkerId === undefined"
        >
          {{ "form_fields.next" | translate }}
          <span class="custom-button-icon next"></span>
        </app-button>
      </div>
    </div>
  </form>
}
